import { defineStore } from "pinia";
import uuid4 from "uuid4";
import { ref } from "vue";

export const useNotificationsStore = defineStore("notifications", () => {

  const notifications = ref([]);

  const pushNotification = function (message, type) {
    const id = uuid4();
    notifications.value.push({ message, type, id: id });
    return id;
  }

  const pushSuccess = function (message) {
    const id = pushNotification(message, 'success')
    setTimeout(() => removeNotification(id), 3000);
  }

  const pushError = function(message) {
    const id = pushNotification(message, 'error')
    setTimeout(() => removeNotification(id), 3000);
  }

  const removeNotification = function (id) {
    notifications.value.splice(notifications.value.findIndex((item) => item.id == id), 1);
  }

  return { notifications, pushNotification, pushSuccess, pushError, removeNotification };
});
